var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "dark:text-lightbgtwo text-darkbgone",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_1494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84128 13.1202C10.2889 13.1168 10.6739 12.9482 11.0201 12.5941L19.2474 4.16572C19.5273 3.8857 19.6716 3.54748 19.6716 3.1451C19.6716 2.31845 19.0185 1.65794 18.2024 1.65794C17.8 1.65794 17.423 1.81959 17.129 2.11651L9.3477 10.1187H10.3413L2.54606 2.11651C2.2561 1.82655 1.88258 1.65794 1.46925 1.65794C0.649566 1.65794 0 2.31845 0 3.1451C0 3.544 0.147727 3.88222 0.420787 4.17319L8.65508 12.5941C9.01615 12.9551 9.38973 13.1202 9.84128 13.1202Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_1494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 12.2404,
    fill: "currentColor",
    transform: "translate(0 0.879791)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.bff84e20a36b8428e9e024a4e1e72f0f.svg";
export { ForwardRef as ReactComponent };